export const PAYU_URL = "https://test.payu.in/_payment";